import React from 'react';
import { connect } from 'react-redux';
import { Card, CardText, CardTitle, CardBody, DashboardSection, Header1 } from 'fiducius-ui';
import { withPermissions } from '../../../routing';
import { NeedAssistance } from '../../../need-assistance';
import Scheduler from '../../../meetings/containers/scheduler';
import FaqQuestion from '../../../faq/components/faq-question';
import { isStringWithContent } from '../../../utils';

const ContributionNeedAssistance = ({ permissions, needAssistanceObject }) => {
  const showSpeakToAnExpertButton = () => {
    if (permissions.clientStatus === 'FUPHB' && permissions.enterpriseEnabled) {
      return true;
    }
  };

  const ContributionAssistanceObject =
    needAssistanceObject.length &&
    needAssistanceObject.find((element) => {
      return element.id === 'Contribution_Assistance';
    });
  const ContributionPromptObject =
    needAssistanceObject.length &&
    needAssistanceObject.find((element) => {
      return element.id === 'ContributionMessagePrompt';
    });
  const needAssistanceText =
    ContributionAssistanceObject && ContributionAssistanceObject.messageContent;
  const needAssistanceAvatarLink =
    ContributionAssistanceObject && ContributionAssistanceObject.avatarLink;
  const needAssistancePrompt = ContributionPromptObject && ContributionPromptObject.messageContent;
  const blocktext =
    isStringWithContent(needAssistanceText) ||
    isStringWithContent(needAssistanceAvatarLink) ||
    isStringWithContent(needAssistancePrompt)
      ? 'block'
      : 'none';

  return (
    <div className="row">
      <div className="col-12 col-lg-12">
        <DashboardSection>
          <div className="row">
            <div className="col-12 col-lg-9">
              <Header1>Need Assistance?</Header1>
            </div>
            {showSpeakToAnExpertButton() && (
              <>
                <div className="col-12 col-lg-3" style={{ 'text-align': 'right' }}>
                  <Scheduler buttonText="Speak to an Expert" />
                </div>
              </>
            )}
          </div>
          <NeedAssistance messageType={'ContributionAlertPrompt'} />
          <Card style={{ display: blocktext }}>
            <CardBody>
              <CardTitle>Information</CardTitle>
              <CardText>
                <NeedAssistance messageType={'Contribution_Assistance'} />
                <NeedAssistance messageType={'ContributionMessagePrompt'} />
              </CardText>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle>FAQs</CardTitle>
              <FaqQuestion question={'When are Contribution payments made?'}>
                <p>
                  Contribution payments are issued on the 1st of the month or the next business day
                  if the 1st occurs on the weekend.
                </p>
              </FaqQuestion>
              <FaqQuestion question={'How are Contribution payments made?'}>
                <p>Contribution payments are made directly to your loan servicer(s).</p>
              </FaqQuestion>
              <FaqQuestion
                question={
                  'After my Contribution account is approved, when will I receive my first payment?'
                }
              >
                <p>
                  It can take up to 60 days for you to receive your first Contribution payment. The
                  first payment to be received is based on the approval date. For example, if your
                  Contribution account is approved in February, you will receive your first payment
                  in April. Please note that you are responsible for any loan payment due prior to
                  your first scheduled Contribution payment.
                </p>
              </FaqQuestion>
              <FaqQuestion
                question={
                  'If Fiducius is managing my student loan forgiveness (Public Service Loan Forgiveness, etc.), how does this impact my Contribution benefit?'
                }
              >
                <p>
                  If you are participating in student loan forgiveness, your monthly Contribution
                  payment will be limited to your Income-Driven Repayment (IDR) amount. When
                  completing the steps to set up your Contribution account, the payment amount and
                  payment due date will default to the information you supplied via the student loan
                  forgiveness process.
                </p>
              </FaqQuestion>
              <FaqQuestion
                question={
                  'When adding Contribution accounts should I input my loans individually as separate accounts or my overall loan balance as one account?'
                }
              >
                <p>
                  Although you have the ability to input individual loans for payment, Fiducius
                  recommends that you set up one Contribution account per account number at your
                  loan servicer(s) (if applicable) that encompasses your overall loan balance.
                </p>
              </FaqQuestion>
              <FaqQuestion question={'Where can I find my Proof of Account/Loan?'}>
                <p>
                  Proof of account/loan is a document provided by your loan servicer. It should
                  include:
                  <ul>
                    <li>Your Name</li>
                    <li>Servicer/Bank Name</li>
                    <li>Payment Address</li>
                    <li>Account Number</li>
                    <li>Account Balance</li>
                    <li>Monthly Payment</li>
                  </ul>
                  Common names for this document include "Printable Account Information," "Loan
                  Summary/Mortgage Verification," or "Student Loan Obligation Statement."
                </p>
              </FaqQuestion>
              <FaqQuestion
                question={
                  'What if my student loan monthly payment exceeds the contribution provided by my employer?'
                }
              >
                <p>
                  If your student loan monthly payment is higher than your employer’s maximum
                  contribution, the employer’s payment will be sent to your loan servicer. You will
                  only be responsible to ensure that the remaining balance of the monthly payment is
                  being made.
                </p>
              </FaqQuestion>
            </CardBody>
          </Card>
        </DashboardSection>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  todos: Object.values(state.todos.cache),
  needAssistanceObject: Object.values(state.needAssistance.cache),
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withPermissions(ContributionNeedAssistance));
